import { DossierHelpPlan } from "app/_models/dossier-help-plan.model";

export class serviceModel {
    itmId: string ;
    itmCode: string;
    itmShortName: string;
    itmLongName: string;
    itmInactive: boolean;
    itmCreatedBy: string;
    itmLastModifiedBy: string;
    itmLastModifiedDate: Date;
    itmCreatedDate: Date;
    itmComment: string;
    itmProductId : string;
    itmProduct : any;
    helpPlans :string [];
    
}